import axios from "axios";
import { configUrl } from "../../config";


export const getCollegeByCode = async (predictorType, collegeCode, selectedCollege, category, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/predictor/${predictorType}/getCollegeByCode`, {
            collegeCode: collegeCode || selectedCollege,
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching college by code:", error);
        throw error;
    }
};

export const getPharmaCollegeByCode = async (collegeCode, selectedCollege, category, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/getPharmaCollegeByCode`, {
            collegeCode: collegeCode || selectedCollege,
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching college by code:", error);
        throw error;
    }
};
